import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import { TilesGridCellOverlay } from './tiles-grid-cell-overlay';
import { withAdsStudioStyles } from '../../../theme/with-ads-studio-styles';
import {
  getCellCardStyle,
  getCellCardWithOverlayStyle,
} from '../styles/tiles-grid-cell-card-style';

const CellCardWithOverlay = ({
  children,
  isOverlayEnabled,
  isCellFocused,
  renderOverlayContent,
  renderStaticOverlayContent,
  onClick,
  customCellCardClass,
  classes,
}) => {
  const onClickFunc = (event) => {
    if (onClick) {
      onClick();
    }
    if (event && event.stopPropagation) { event.stopPropagation(); }
    if (event && event.preventDefault) { event.preventDefault(); }
  };

  const onKeyDown = (event) => {
    if (event.keyCode === 13) { // Enter key
      onClickFunc();
    }
  };

  return (
    // eslint-disable-next-line jsx-a11y/no-static-element-interactions
    <div
      className={classnames(
        'cell-content',
        classes.containerClass || classes.cellCardContainer,
        customCellCardClass || classes.cellCardContainerOverflow,
        classes.cellCardWithOverlayContainer,
        isCellFocused && classes.focused
      )}
      onClick={onClickFunc}
      onKeyDown={onKeyDown}
    >
      {children}
      {isOverlayEnabled && (
        <TilesGridCellOverlay>
          <div className="cell-overlay-actions">
            {renderOverlayContent ? renderOverlayContent() : null}
          </div>
          { renderStaticOverlayContent ?
            <div className="static-cell-overlay-items">
              {renderStaticOverlayContent()}
            </div>
          : null}
        </TilesGridCellOverlay>
      )}
    </div>
  );
};

CellCardWithOverlay.propTypes = {
  children: PropTypes.node.isRequired,
  renderOverlayContent: PropTypes.func,
  renderStaticOverlayContent: PropTypes.func,
  isOverlayEnabled: PropTypes.bool,
  isCellFocused: PropTypes.bool,
  onClick: PropTypes.func,
  customCellCardClass: PropTypes.string,
  classes: PropTypes.shape({
    containerClass: PropTypes.string,
    cellCardContainer: PropTypes.string,
    cellCardWithOverlayContainer: PropTypes.string,
    cellCardContainerOverflow: PropTypes.string,
    focused: PropTypes.string,
  }).isRequired,
};

CellCardWithOverlay.defaultProps = {
  isOverlayEnabled: true,
  isCellFocused: false,
  renderOverlayContent: null,
  renderStaticOverlayContent: null,
  customCellCardClass: undefined,
  onClick: undefined,
};

const CellCard = ({ children, classes, customCellCardClass }) => (
  <div className={classnames('cell-content', classes.containerClass || classes.cellCardContainer, customCellCardClass)} >
    {children}
  </div>
);

CellCard.propTypes = {
  children: PropTypes.node.isRequired,
  customCellCardClass: PropTypes.string,
  classes: PropTypes.shape({
    containerClass: PropTypes.string,
    cellCardContainer: PropTypes.string,
  }).isRequired,
};

CellCard.defaultProps = {
  customCellCardClass: undefined,
};

export const TilesGridCellCard = withAdsStudioStyles(CellCard, getCellCardStyle);
export const TilesGridCellCardWithOverlay = withAdsStudioStyles(CellCardWithOverlay, getCellCardWithOverlayStyle);
